const getConcreteAgeSchmidt = (age: string | number) => (+age > 28 ? '> 28' : age);

export default getConcreteAgeSchmidt;
